import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({
  name: 'dateWrapper',
  standalone: false, // eslint-disable-line
})
export class DateWrapperPipe implements PipeTransform {
  private date = inject(DatePipe);

  transform(value: any, args?: any): any {
    if (!value) {
      return '';
    }

    const date = new Date(value.replace(/-/g, '/'));
    return this.date.transform(date, args);
  }
}
